import { Component, OnInit, OnDestroy, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../../../services';

import { BsModalService } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';

import { UserLoginForm } from 'app/models';

@Component({
  selector     : 'approval-modal',
  templateUrl  : 'approval-modal.component.html',
  encapsulation: ViewEncapsulation.None

})
export class ApprovalModal implements OnInit, OnDestroy {
  @Input('approvalModalRef') approvalModalRef;
  @Output() emitApproval  = new EventEmitter<any>();
  model   : UserLoginForm = {};
  flagInvalidUser: boolean;
  loading        : boolean;

  constructor(
    private translate   : TranslateService,
    private modalService: BsModalService,
    private authService : AuthenticationService
  ) {
  }
  
  ngOnInit(): void {
    this.flagInvalidUser = false;
    this.loading         = false;
  }

  ngOnDestroy(): void {
    this.flagInvalidUser = false;

  }

  login() {
    const timestamp    = new Date().getTime().toString();
    const user         = JSON.parse(localStorage.getItem('currentRollUser'));
          this.loading = true;
    console.log('login', this.model)
    this.authService
      .loginCheckRole(this.model.username, this.model.password)
      .take(1)
      .subscribe(
          (output: any) => {
            // This function will just be responsible for returning the role of the user.
            // The component that calls this function will be responsible for checking if the user has the necessary permissions.
            if(output.role){
              this.loading = false;
              // this.emitApproval.emit({ approval : true, approvalUser : this.model.username});
              this.emitApproval.emit(output);
              this.flagInvalidUser = false;
            }else{
              this.loading         = false;
              this.flagInvalidUser = true;
            }
          }
      );
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/approval-modal/approval-modal.component.ts